/* eslint-disable */
export default {
  createLog: 'Criar registo',
  creating: 'A criar',
  save: 'Guardar',
  saving: 'A guardar',
  saved: 'Guardado',
  view: 'Ver',
  creatingFailed: 'Falha ao criar.',
  savingFailed: 'Falha ao guardar.',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
